export default __webpack_public_path__ + "static/media/PneumaticSystemsImg.7acf363d.jpg";